var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _path, _rect12, _rect13, _path2, _rect14, _rect15, _path3, _rect16, _ellipse, _ellipse2, _ellipse3, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbnail2A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 225,
    viewBox: "0 0 328 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 328,
    height: 225,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 266.277,
    y: 9.45557,
    width: 23.7681,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 237.755,
    y: 9.45557,
    width: 23.7681,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 294.725,
    y: 9.45557,
    width: 23.7681,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50732,
    y: 9.45557,
    width: 95.0725,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50732,
    y: 21.1743,
    width: 308.986,
    height: 1.875,
    fill: "#E0E0E0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8843,
    y: 46.4868,
    width: 1.90145,
    height: 154.028,
    fill: "#E0E0E0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50732,
    y: 32.4243,
    width: 47.5362,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 272.903,
    y: 46.4868,
    width: 45.5891,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 272.903,
    y: 100.957,
    width: 45.5891,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 272.903,
    y: 155.424,
    width: 45.5891,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 272.903,
    y: 54.0781,
    width: 45.5891,
    height: 37.5,
    stroke: "#CCCCCC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 276.266,
    y: 57.3921,
    width: 38.863,
    height: 30.872,
    fill: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M302.424 69.0524C302.424 68.3708 301.846 67.794 301.163 67.794H298.851L298.509 66.9551C298.325 66.457 297.852 66.1162 297.327 66.1162H294.042C293.517 66.1162 293.044 66.457 292.86 66.9551L292.545 67.794H290.233C289.523 67.794 288.972 68.3708 288.972 69.0524V76.6026C288.972 77.3105 289.523 77.861 290.233 77.861H301.163C301.846 77.861 302.424 77.3105 302.424 76.6026V69.0524ZM298.851 72.8275C298.851 74.584 297.432 75.9734 295.698 75.9734C293.937 75.9734 292.545 74.584 292.545 72.8275C292.545 71.0973 293.937 69.6816 295.698 69.6816C297.432 69.6816 298.851 71.0973 298.851 72.8275ZM298.01 72.8275C298.01 71.5691 296.959 70.5205 295.698 70.5205C294.41 70.5205 293.386 71.5691 293.386 72.8275C293.386 74.1121 294.41 75.1345 295.698 75.1345C296.959 75.1345 298.01 74.1121 298.01 72.8275Z",
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 272.903,
    y: 108.549,
    width: 45.5891,
    height: 37.5,
    stroke: "#CCCCCC"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 276.266,
    y: 111.862,
    width: 38.863,
    height: 30.872,
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M302.424 123.523C302.424 122.841 301.846 122.264 301.163 122.264H298.851L298.509 121.425C298.325 120.927 297.852 120.586 297.327 120.586H294.042C293.517 120.586 293.044 120.927 292.86 121.425L292.545 122.264H290.233C289.523 122.264 288.972 122.841 288.972 123.523V131.073C288.972 131.781 289.523 132.331 290.233 132.331H301.163C301.846 132.331 302.424 131.781 302.424 131.073V123.523ZM298.851 127.298C298.851 129.054 297.432 130.444 295.698 130.444C293.937 130.444 292.545 129.054 292.545 127.298C292.545 125.567 293.937 124.152 295.698 124.152C297.432 124.152 298.851 125.567 298.851 127.298ZM298.01 127.298C298.01 126.039 296.959 124.991 295.698 124.991C294.41 124.991 293.386 126.039 293.386 127.298C293.386 128.582 294.41 129.605 295.698 129.605C296.959 129.605 298.01 128.582 298.01 127.298Z",
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 272.903,
    y: 163.015,
    width: 45.5891,
    height: 37.5,
    stroke: "#CCCCCC"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 276.266,
    y: 166.329,
    width: 38.863,
    height: 30.872,
    fill: "#E0E0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M302.424 177.989C302.424 177.307 301.846 176.731 301.163 176.731H298.851L298.509 175.892C298.325 175.394 297.852 175.053 297.327 175.053H294.042C293.517 175.053 293.044 175.394 292.86 175.892L292.545 176.731H290.233C289.523 176.731 288.972 177.307 288.972 177.989V185.539C288.972 186.247 289.523 186.798 290.233 186.798H301.163C301.846 186.798 302.424 186.247 302.424 185.539V177.989ZM298.851 181.764C298.851 183.521 297.432 184.91 295.698 184.91C293.937 184.91 292.545 183.521 292.545 181.764C292.545 180.034 293.937 178.618 295.698 178.618C297.432 178.618 298.851 180.034 298.851 181.764ZM298.01 181.764C298.01 180.506 296.959 179.457 295.698 179.457C294.41 179.457 293.386 180.506 293.386 181.764C293.386 183.049 294.41 184.071 295.698 184.071C296.959 184.071 298.01 183.049 298.01 181.764Z",
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 185.541,
    y: 9.45557,
    width: 47.5362,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.8349,
    cy: 49.7681,
    rx: 3.32754,
    ry: 3.28125,
    fill: "#CCCCCC"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.8349,
    cy: 104.238,
    rx: 3.32754,
    ry: 3.28125,
    fill: "#CCCCCC"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.8349,
    cy: 158.705,
    rx: 3.32754,
    ry: 3.28125,
    fill: "#CCCCCC"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7681,
    y: 46.4868,
    width: 45.5891,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7681,
    y: 100.957,
    width: 45.5891,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7681,
    y: 155.424,
    width: 45.5891,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 69.3574,
    y: 46.4868,
    width: 45.5891,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 69.3574,
    y: 100.957,
    width: 45.5891,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 69.3574,
    y: 155.424,
    width: 45.5891,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 114.947,
    y: 46.4868,
    width: 157.957,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 114.947,
    y: 100.957,
    width: 157.957,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 114.947,
    y: 155.424,
    width: 157.957,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7681,
    y: 54.0781,
    width: 45.5891,
    height: 37.5,
    stroke: "#CCCCCC"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7681,
    y: 108.549,
    width: 45.5891,
    height: 37.5,
    stroke: "#CCCCCC"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7681,
    y: 163.015,
    width: 45.5891,
    height: 37.5,
    stroke: "#CCCCCC"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 69.3574,
    y: 54.0781,
    width: 45.5891,
    height: 37.5,
    stroke: "#CCCCCC"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 69.3574,
    y: 108.549,
    width: 45.5891,
    height: 37.5,
    stroke: "#CCCCCC"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 69.3574,
    y: 163.015,
    width: 45.5891,
    height: 37.5,
    stroke: "#CCCCCC"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 114.947,
    y: 54.0781,
    width: 157.957,
    height: 37.5,
    stroke: "#CCCCCC"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 114.947,
    y: 108.549,
    width: 157.957,
    height: 37.5,
    stroke: "#CCCCCC"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 114.947,
    y: 163.015,
    width: 157.957,
    height: 37.5,
    stroke: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail2A);
export default __webpack_public_path__ + "static/media/thumbnail-2-a.0bfa021a8daf9613d5bf928f1fd7e3fc.svg";
export { ForwardRef as ReactComponent };